import { ContractDetailsContext } from '@/contexts'
import { useContext } from 'react'

export const useContractDetailsContext = () => {
  const context = useContext(ContractDetailsContext)

  if (!context) throw new Error('useContractDetailsContext have to be wrapped by ContractDetailsContextProvider')

  return context
}
